<div class="main-container">
    <button class="hf-hour-select-button hf-inactive-hour-select-button">
        <div class="layout-row">
            <div class="hf-tv-screen-hour-info-chip-list">
                <div
                    *ngFor="let hour of displayHour"
                    class="hf-tv-screen-hour-info-item"
                    [ngClass]="{
                        'hf-tv-screen-info-chip-selected-color':
                            this.screenFilterForm.get('hourType')?.value === hour?.name && !shouldOnlyDisplayBreakCodeOption
                    }"
                    (click)="selectedDisplayHourType(hour)">
                    {{ hour.display }}
                </div>
            </div>
        </div>
        <button
            class="hf-hour-select-button hf-hour-button-custom"
            (click)="onShowDropDownButtonClick()"
            [ngClass]="!showDropDown ? 'hf-active-hour-select-button' : 'hf-inactive-hour-select-button'">
            <mat-icon class="hf-small-icon" matPrefix>schedule</mat-icon>
            <span class="hf-hour-info"> de {{ this.hourForm.value.startHour }} à {{ this.hourForm.value.endHour }} </span>
            <mat-icon>arrow_drop_down</mat-icon>
        </button>
    </button>
    <div class="hf-dropdown" [ngClass]="showDropDown ? 'hf-visible-dropdown' : 'hf-invisible-dropdown'">
        <div>
            <mat-checkbox class="tv-ns-blue-checkbox" [checked]="filterAllTimeSlot.ischeck" (change)="onSelectAllTimeSlotChange()">
                {{ filterAllTimeSlot.name }}
            </mat-checkbox>
        </div>
        <div class="hf-horizontal-separator"></div>
        <div [formGroup]="hourForm">
            <div class="hf-tv-container-hour-input">
                <span class="hf-label-from">De</span>
                <div class="tv-table-input-black width-60px">
                    <mat-form-field (click)="clearHour('startHour')" class="tv-input-timer">
                        <input matInput formControlName="startHour" appTimeMask />
                    </mat-form-field>
                </div>

                <span class="hf-label-custom">à</span>
                <div class="tv-table-input-black width-60px">
                    <mat-form-field (click)="clearHour('endHour')" class="tv-input-timer">
                        <input matInput formControlName="endHour" appTimeMask />
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>
</div>
